import { render, staticRenderFns } from "./installStep2.vue?vue&type=template&id=17938214&scoped=true"
import script from "./installStep2.vue?vue&type=script&lang=js"
export * from "./installStep2.vue?vue&type=script&lang=js"
import style0 from "./installStep2.vue?vue&type=style&index=0&id=17938214&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17938214",
  null
  
)

export default component.exports